module.exports = __webpack_public_path__ + "static/media/54.1eb887a0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/polished/54.jpg
// module id = 615
// module chunks = 0